import PropTypes from 'prop-types';
import { intlShape } from '@prospectus/common/types/intlShape';

const classicEdxProgramPropTypes = {
  program: PropTypes.shape({
    uuid: PropTypes.string,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    authoringOrganizations: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string,
    })),
    courses: PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.string,
    })),
    type: PropTypes.string,
    courseCount: PropTypes.number,
    marketingPath: PropTypes.string,
    cardType: PropTypes.string,
    inProspectus: PropTypes.bool,
  }).isRequired,
  isTestimonialCard: PropTypes.bool,
  columnClass: PropTypes.string,
  intl: intlShape.isRequired,
};

export default classicEdxProgramPropTypes;
